var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pga-data-table", {
    attrs: {
      title: "Tech Areas",
      headers: _vm.headers,
      data: _vm.TechAreasList,
      loading: _vm.isLoading,
      "col-props": ["Status", "Code"],
    },
    on: { "row-clicked": _vm.rowClicked },
    scopedSlots: _vm._u([
      {
        key: "column-Status",
        fn: function (props) {
          return [
            _c("pga-entity-status", {
              model: {
                value: props.row.item.Status,
                callback: function ($$v) {
                  _vm.$set(props.row.item, "Status", $$v)
                },
                expression: "props.row.item.Status",
              },
            }),
          ]
        },
      },
      {
        key: "column-Code",
        fn: function (props) {
          return [
            _vm._v(
              " " +
                _vm._s(props.row.item.BusinessLine.Code) +
                "/" +
                _vm._s(props.row.item.Code) +
                " "
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }